export const environment = {
  production: true,
  api_url: 'https://api.hygiene-expert.com',
  url_btn_hec: 'https://button.hygiene-expert.com/btn_hec.js'
};
